import { ApplicationState } from '../../types';

export const selectDomainsList = ({ domains }: ApplicationState) => domains?.list;
export const selectIsListPending = ({ domains }: ApplicationState) => domains?.fetchList.isPending;
export const selectIsListError = ({ domains }: ApplicationState) => domains?.fetchList.isError;
export const selectNewDomain = ({ domains }: ApplicationState) => domains?.addNewDomain.params.domain;
export const selectNewDomainPending = ({ domains }: ApplicationState) => domains?.addNewDomain.isPending;
